<template>
    <v-select
        :options="question.settings.options"
        dir="rtl"
        multiple
        @input="$emit('input', $event)"
    >
        <template #no-options> {{ $t('form.chooseFromList') }}; </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';

export default {
    components: {
        vSelect
    },

    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
